/**
 * Central copy for loading states. Change strings here to update UI across the app
 * (PageLoader, ContentLoader, AppLoader, and inline permission / form messages).
 */
export const loaderMessages = {
  /** Generic full-page / inline default */
  page: 'Loading...',
  /** Checking or loading RBAC / feature permissions */
  permissions: 'Loading permissions...',
  /** Form schema / form definition */
  form: 'Loading form...',
  /** Filling form instance data */
  formData: 'Loading form data...',
  /** Options list: form names, etc. */
  forms: 'Loading forms...',
  /** Document / template editor */
  template: 'Loading template...',
  /** Fee module */
  feeStructure: 'Loading fee structure...',
  categories: 'Loading categories...',
  /** Auth / workspace (navigate action) */
  settingUpWorkspace: 'Setting up your workspace...',
  workspaceSetup: 'Please wait while we set up your workspace',
  workspacePrepare: 'Please wait while we prepare your selected workspace',
  switchingWorkspace: 'Switching workspace...',
  workspaceSwitch: 'Please wait while we switch to your selected workspace',
  /** Session */
  loggingOut: 'Logging out...',
  loggingOutDescription: 'Please wait while we log you out',
  /** Public profile flow */
  submittingProfile: 'Submitting your profile. Please wait...',
} as const

export type LoaderMessageKey = keyof typeof loaderMessages

/** Message sets for `ContentLoader` `action` prop — rotate in UI while loading */
export const contentLoaderActionMessages = {
  load: [
    'Loading {entity}...',
    'Fetching your data...',
    'Just a moment...',
    'Preparing content...',
  ],
  navigate: [
    'Navigating to {entity}...',
    'Loading page...',
    'Almost there...',
    'Getting things ready...',
  ],
  fetch: [
    'Fetching {entity}...',
    'Loading data...',
    'Please wait...',
    'Retrieving information...',
  ],
  process: [
    'Processing your request...',
    'Working on it...',
    'Almost there...',
    'Just a moment...',
  ],
  payment: [
    'Confirming payment...',
    'Verifying subscription...',
    'Processing payment confirmation...',
    'Activating your subscription...',
  ],
  custom: ['Processing...', 'Please wait...', 'Loading...'],
} as const
